import Button from '../ui/Button';

const ReloadIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className="h-3.5 w-3.5">
    <path
      d="M3 12a9 9 0 0 1 15.5-6.3M21 12a9 9 0 0 1-15.5 6.3M21 4v5h-5M3 20v-5h5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

function CrudCardHeader({ title, count, onAdd, onRecargar, addLabel }) {
  return (
    <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h2 className="font-serif text-2xl tracking-tight">
          <span className="italic text-gradient">{title}</span>
        </h2>
        <p className="mt-1 text-xs font-mono uppercase tracking-[0.18em] text-white/40">
          gestión · {count} registros
        </p>
      </div>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={onRecargar}
          aria-label="Recargar"
          title="Recargar"
          className="inline-flex h-11 w-11 items-center justify-center rounded-2xl border border-white/10 bg-white/[0.04] text-white/65 transition hover:bg-white/[0.08] hover:text-white"
        >
          <ReloadIcon />
        </button>
        <Button variant="secondary" onClick={onAdd}>
          {addLabel}
        </Button>
      </div>
    </div>
  );
}

export default CrudCardHeader;